import { jsx } from 'react/jsx-runtime';
import React, { useRef, useMemo, useEffect, useContext } from 'react';

var BitsComponents;

(function (BitsComponents) {
  BitsComponents["Button"] = "Button";
  BitsComponents["SegmentedContainer"] = "SegmentedContainer";
  BitsComponents["SegmentedButton"] = "SegmentedButton";
  BitsComponents["Tabs"] = "Tabs";
  BitsComponents["ColorPicker"] = "ColorPicker";
  BitsComponents["Link"] = "Link";
  BitsComponents["Alert"] = "Alert";
  BitsComponents["TextInput"] = "TextInput";
  BitsComponents["Typography"] = "Typography";
  BitsComponents["Avatar"] = "Avatar";
  BitsComponents["Tooltip"] = "Tooltip";
  BitsComponents["Menu"] = "Menu";
  BitsComponents["Checkbox"] = "Checkbox";
  BitsComponents["MenuItem"] = "MenuItem";
  BitsComponents["MenuToggleItem"] = "MenuToggleItem";
  BitsComponents["MenuSwitchItem"] = "MenuSwitchItem";
  BitsComponents["MenuDividerItem"] = "MenuDividerItem";
  BitsComponents["MenuCheckItem"] = "MenuCheckItem";
  BitsComponents["MenuNestedItem"] = "MenuNestedItem";
  BitsComponents["Loader"] = "Loader";
  BitsComponents["Dropdown"] = "Dropdown";
  BitsComponents["MenuSectionTitle"] = "MenuSectionTitle";
  BitsComponents["Switch"] = "Switch";
  BitsComponents["Breadcrumbs"] = "Breadcrumbs";
})(BitsComponents || (BitsComponents = {}));

var MuiComponents;

(function (MuiComponents) {
  MuiComponents["button"] = "button";
})(MuiComponents || (MuiComponents = {}));

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$b =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$9 = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$8 = fails$9;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$8(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$2 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var toString = {}.toString;

var classofRaw$1 = function (it) {
  return toString.call(it).slice(8, -1);
};

var fails$7 = fails$9;
var classof$3 = classofRaw$1;

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$7(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$3(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$2 = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$3 = indexedObject;
var requireObjectCoercible$1 = requireObjectCoercible$2;

var toIndexedObject$4 = function (it) {
  return IndexedObject$3(requireObjectCoercible$1(it));
};

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$b = function (argument) {
  return typeof argument === 'function';
};

var isCallable$a = isCallable$b;

var isObject$6 = function (it) {
  return typeof it === 'object' ? it !== null : isCallable$a(it);
};

var global$a = global$b;
var isCallable$9 = isCallable$b;

var aFunction = function (argument) {
  return isCallable$9(argument) ? argument : undefined;
};

var getBuiltIn$4 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$a[namespace]) : global$a[namespace] && global$a[namespace][method];
};

var getBuiltIn$3 = getBuiltIn$4;

var engineUserAgent = getBuiltIn$3('navigator', 'userAgent') || '';

var global$9 = global$b;
var userAgent = engineUserAgent;

var process = global$9.process;
var Deno = global$9.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] < 4 ? 1 : match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

var engineV8Version = version && +version;

/* eslint-disable es/no-symbol -- required for testing */

var V8_VERSION$1 = engineV8Version;
var fails$6 = fails$9;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$6(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION$1 && V8_VERSION$1 < 41;
});

/* eslint-disable es/no-symbol -- required for testing */

var NATIVE_SYMBOL$1 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$1
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var isCallable$8 = isCallable$b;
var getBuiltIn$2 = getBuiltIn$4;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$2('Symbol');
  return isCallable$8($Symbol) && Object(it) instanceof $Symbol;
};

var tryToString$1 = function (argument) {
  try {
    return String(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$7 = isCallable$b;
var tryToString = tryToString$1;

// `Assert: IsCallable(argument) is true`
var aCallable$2 = function (argument) {
  if (isCallable$7(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a function');
};

var aCallable$1 = aCallable$2;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$1 = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable$1(func);
};

var isCallable$6 = isCallable$b;
var isObject$5 = isObject$6;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$6(fn = input.toString) && !isObject$5(val = fn.call(input))) return val;
  if (isCallable$6(fn = input.valueOf) && !isObject$5(val = fn.call(input))) return val;
  if (pref !== 'string' && isCallable$6(fn = input.toString) && !isObject$5(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var shared$3 = {exports: {}};

var global$8 = global$b;

var setGlobal$3 = function (key, value) {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(global$8, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$8[key] = value;
  } return value;
};

var global$7 = global$b;
var setGlobal$2 = setGlobal$3;

var SHARED = '__core-js_shared__';
var store$3 = global$7[SHARED] || setGlobal$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$3.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.18.1',
  mode: 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});

var requireObjectCoercible = requireObjectCoercible$2;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$3 = function (argument) {
  return Object(requireObjectCoercible(argument));
};

var toObject$2 = toObject$3;

var hasOwnProperty = {}.hasOwnProperty;

var has$7 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty.call(toObject$2(it), key);
};

var id = 0;
var postfix = Math.random();

var uid$2 = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};

var global$6 = global$b;
var shared$2 = shared$3.exports;
var has$6 = has$7;
var uid$1 = uid$2;
var NATIVE_SYMBOL = nativeSymbol;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore = shared$2('wks');
var Symbol$1 = global$6.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$5 = function (name) {
  if (!has$6(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (NATIVE_SYMBOL && has$6(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};

var isObject$4 = isObject$6;
var isSymbol$1 = isSymbol$2;
var getMethod = getMethod$1;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$4 = wellKnownSymbol$5;

var TO_PRIMITIVE = wellKnownSymbol$4('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$4(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = exoticToPrim.call(input, pref);
    if (!isObject$4(result) || isSymbol$1(result)) return result;
    throw TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : String(key);
};

var global$5 = global$b;
var isObject$3 = isObject$6;

var document = global$5.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$3(document) && isObject$3(document.createElement);

var documentCreateElement = function (it) {
  return EXISTS$1 ? document.createElement(it) : {};
};

var DESCRIPTORS$5 = descriptors;
var fails$5 = fails$9;
var createElement = documentCreateElement;

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !DESCRIPTORS$5 && !fails$5(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$4 = descriptors;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$1 = createPropertyDescriptor$2;
var toIndexedObject$3 = toIndexedObject$4;
var toPropertyKey$1 = toPropertyKey$2;
var has$5 = has$7;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$4 ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$3(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has$5(O, P)) return createPropertyDescriptor$1(!propertyIsEnumerableModule$1.f.call(O, P), O[P]);
};

var objectDefineProperty = {};

var isObject$2 = isObject$6;

// `Assert: Type(argument) is Object`
var anObject$2 = function (argument) {
  if (isObject$2(argument)) return argument;
  throw TypeError(String(argument) + ' is not an object');
};

var DESCRIPTORS$3 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var anObject$1 = anObject$2;
var toPropertyKey = toPropertyKey$2;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$3 ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$1(O);
  P = toPropertyKey(P);
  anObject$1(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$2 = descriptors;
var definePropertyModule$1 = objectDefineProperty;
var createPropertyDescriptor = createPropertyDescriptor$2;

var createNonEnumerableProperty$3 = DESCRIPTORS$2 ? function (object, key, value) {
  return definePropertyModule$1.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var redefine$2 = {exports: {}};

var isCallable$5 = isCallable$b;
var store$1 = sharedStore;

var functionToString = Function.toString;

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$5(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

var inspectSource$3 = store$1.inspectSource;

var global$4 = global$b;
var isCallable$4 = isCallable$b;
var inspectSource$2 = inspectSource$3;

var WeakMap$1 = global$4.WeakMap;

var nativeWeakMap = isCallable$4(WeakMap$1) && /native code/.test(inspectSource$2(WeakMap$1));

var shared$1 = shared$3.exports;
var uid = uid$2;

var keys = shared$1('keys');

var sharedKey$1 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$3 = {};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$3 = global$b;
var isObject$1 = isObject$6;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$3;
var objectHas = has$7;
var shared = sharedStore;
var sharedKey = sharedKey$1;
var hiddenKeys$2 = hiddenKeys$3;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var WeakMap = global$3.WeakMap;
var set, get, has$4;

var enforce = function (it) {
  return has$4(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$1(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    if (wmhas.call(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has$4 = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys$2[STATE] = true;
  set = function (it, metadata) {
    if (objectHas(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$2(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has$4 = function (it) {
    return objectHas(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has$4,
  enforce: enforce,
  getterFor: getterFor
};

var DESCRIPTORS$1 = descriptors;
var has$3 = has$7;

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$1 && Object.getOwnPropertyDescriptor;

var EXISTS = has$3(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$1 || (DESCRIPTORS$1 && getDescriptor(FunctionPrototype, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var global$2 = global$b;
var isCallable$3 = isCallable$b;
var has$2 = has$7;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$3;
var setGlobal$1 = setGlobal$3;
var inspectSource$1 = inspectSource$3;
var InternalStateModule = internalState;
var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(redefine$2.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== undefined ? options.name : key;
  var state;
  if (isCallable$3(value)) {
    if (String(name).slice(0, 7) === 'Symbol(') {
      name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    }
    if (!has$2(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
      createNonEnumerableProperty$1(value, 'name', name);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    }
  }
  if (O === global$2) {
    if (simple) O[key] = value;
    else setGlobal$1(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty$1(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return isCallable$3(this) && getInternalState(this).source || inspectSource$1(this);
});

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
var toInteger$2 = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};

var toInteger$1 = toInteger$2;

var min$1 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$2 = function (argument) {
  return argument > 0 ? min$1(toInteger$1(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toInteger = toInteger$2;

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};

var toIndexedObject$2 = toIndexedObject$4;
var toLength$1 = toLength$2;
var toAbsoluteIndex = toAbsoluteIndex$1;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$1 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$2($this);
    var length = toLength$1(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$1(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$1(false)
};

var has$1 = has$7;
var toIndexedObject$1 = toIndexedObject$4;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$1 = hiddenKeys$3;

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$1(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has$1(hiddenKeys$1, key) && has$1(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has$1(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$2 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$2;

var hiddenKeys = enumBugKeys$1.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$1 = getBuiltIn$4;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject = anObject$2;

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$1('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

var has = has$7;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var fails$4 = fails$9;
var isCallable$2 = isCallable$b;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$2(detection) ? fails$4(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var global$1 = global$b;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty = createNonEnumerableProperty$3;
var redefine$1 = redefine$2.exports;
var setGlobal = setGlobal$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced = isForced_1;

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$1;
  } else if (STATIC) {
    target = global$1[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global$1[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine$1(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys = enumBugKeys$2;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$1 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};

var DESCRIPTORS = descriptors;
var fails$3 = fails$9;
var objectKeys = objectKeys$1;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$1 = toObject$3;
var IndexedObject$2 = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$3(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$1(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject$2(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$2 = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$2({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});

var InteractionsTypes;

(function (InteractionsTypes) {
  InteractionsTypes["Click"] = "Click";
  InteractionsTypes["Show"] = "Show";
  InteractionsTypes["Hide"] = "Hide";
})(InteractionsTypes || (InteractionsTypes = {}));
var InteractionsContext = /*#__PURE__*/React.createContext({});
var InteractionsProvider = function InteractionsProvider(_ref) {
  var onComponentInteraction = _ref.onComponentInteraction,
      children = _ref.children;
  var onComponentClickRef = useRef(onComponentInteraction);
  onComponentClickRef.current = onComponentInteraction;
  var providerValue = useMemo(function () {
    var callback = function callback(options) {
      var _a;

      (_a = onComponentClickRef.current) === null || _a === void 0 ? void 0 : _a.call(onComponentClickRef, options);
    };

    return {
      onComponentInteraction: callback
    };
  }, []);
  useEffect(function () {
    // @ts-ignore
    window.analytics = window.analytics || {}; // @ts-ignore

    window.analytics.onComponentClick = providerValue.onComponentInteraction;
    return function () {
      // @ts-ignore
      window.analytics = window.analytics || {}; // @ts-ignore

      window.analytics.onComponentClick = null;
    };
  }, [providerValue]);
  return jsx(InteractionsContext.Provider, Object.assign({
    value: providerValue
  }, {
    children: children
  }), void 0);
};

var CustomizationsContext = /*#__PURE__*/React.createContext({
  components: {},
  behaviors: {}
});
var CustomizationsProvider = function CustomizationsProvider(props) {
  var providerValue = useMemo(function () {
    var components = props.components || {};
    var behaviors = props.behaviors || {};
    return {
      components: components,
      behaviors: behaviors
    };
  }, [props.components]);
  return jsx(CustomizationsContext.Provider, Object.assign({
    value: providerValue
  }, {
    children: props.children
  }), void 0);
};

var aCallable = aCallable$2;

// optional / simple context binding
var functionBindContext = function (fn, that, length) {
  aCallable(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var classof$2 = classofRaw$1;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$1 = Array.isArray || function isArray(argument) {
  return classof$2(argument) == 'Array';
};

var wellKnownSymbol$3 = wellKnownSymbol$5;

var TO_STRING_TAG$1 = wellKnownSymbol$3('toStringTag');
var test = {};

test[TO_STRING_TAG$1] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$1 = isCallable$b;
var classofRaw = classofRaw$1;
var wellKnownSymbol$2 = wellKnownSymbol$5;

var TO_STRING_TAG = wellKnownSymbol$2('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$1 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable$1(O.callee) ? 'Arguments' : result;
};

var fails$2 = fails$9;
var isCallable = isCallable$b;
var classof = classof$1;
var getBuiltIn = getBuiltIn$4;
var inspectSource = inspectSource$3;

var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = constructorRegExp.exec;
var INCORRECT_TO_STRING = !constructorRegExp.exec(function () { /* empty */ });

var isConstructorModern = function (argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(Object, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function (argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
    // we can't check .prototype since constructors produced by .bind haven't it
  } return INCORRECT_TO_STRING || !!exec.call(constructorRegExp, inspectSource(argument));
};

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$1 = !construct || fails$2(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var isArray = isArray$1;
var isConstructor = isConstructor$1;
var isObject = isObject$6;
var wellKnownSymbol$1 = wellKnownSymbol$5;

var SPECIES$1 = wellKnownSymbol$1('species');

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesConstructor$1 = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES$1];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};

var arraySpeciesConstructor = arraySpeciesConstructor$1;

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate$1 = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};

var bind = functionBindContext;
var IndexedObject$1 = indexedObject;
var toObject = toObject$3;
var toLength = toLength$2;
var arraySpeciesCreate = arraySpeciesCreate$1;

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject$1(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push.call(target, value); // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};

var fails$1 = fails$9;
var wellKnownSymbol = wellKnownSymbol$5;
var V8_VERSION = engineV8Version;

var SPECIES = wellKnownSymbol('species');

var arrayMethodHasSpeciesSupport$1 = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails$1(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};

var $$1 = _export;
var $map = arrayIteration.map;
var arrayMethodHasSpeciesSupport = arrayMethodHasSpeciesSupport$1;

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$$1({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var fails = fails$9;

var arrayMethodIsStrict$1 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};

var $ = _export;
var IndexedObject = indexedObject;
var toIndexedObject = toIndexedObject$4;
var arrayMethodIsStrict = arrayMethodIsStrict$1;

var nativeJoin = [].join;

var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});

var _muiComponentsList, _bitsComponentsList;
var muiComponentsList = (_muiComponentsList = {}, _muiComponentsList[MuiComponents.button] = ['variant', 'size', 'color', 'loading', 'disabled'], _muiComponentsList);
var bitsComponentsList = (_bitsComponentsList = {}, _bitsComponentsList[BitsComponents.Button] = ['variant', 'size', 'color', 'loading', 'disabled'], _bitsComponentsList);

var useGlobalClassesForComponentsProps = function useGlobalClassesForComponentsProps(key, props) {
  var _useContext = useContext(CustomizationsContext),
      componentsCustomizations = _useContext.components;

  var createDepsFromProps = function createDepsFromProps(key, props) {
    var _a, _b, _c, _d;

    return (_d = (_c = (_b = (_a = componentsCustomizations === null || componentsCustomizations === void 0 ? void 0 : componentsCustomizations[key]) === null || _a === void 0 ? void 0 : _a.globalClasses) === null || _b === void 0 ? void 0 : _b.props) === null || _c === void 0 ? void 0 : _c.map(function (prop) {
      return (props === null || props === void 0 ? void 0 : props[prop]) || '';
    })) !== null && _d !== void 0 ? _d : [];
  };

  return useMemo(function () {
    var _a, _b;

    var componentGlobalClasses = (_a = componentsCustomizations === null || componentsCustomizations === void 0 ? void 0 : componentsCustomizations[key]) === null || _a === void 0 ? void 0 : _a.globalClasses;
    var listOfProps = ((_b = componentGlobalClasses === null || componentGlobalClasses === void 0 ? void 0 : componentGlobalClasses.exposeAll) !== null && _b !== void 0 ? _b : false) ? bitsComponentsList[key] : componentGlobalClasses === null || componentGlobalClasses === void 0 ? void 0 : componentGlobalClasses.props;
    var propsClasses = listOfProps === null || listOfProps === void 0 ? void 0 : listOfProps.map(function (propName) {
      var propValue = props === null || props === void 0 ? void 0 : props[propName];

      if (typeof propValue === 'string' || typeof propValue === 'number') {
        return "kaltura-ds-" + key + "_" + propName + "-" + propValue;
      } else if (typeof propValue === 'boolean' && propValue) {
        return "kaltura-ds-" + key + "_" + propName;
      }

      return '';
    }).join(' ');
    return "kaltura-ds-" + key + (propsClasses ? " " + propsClasses : '');
  }, createDepsFromProps(key, props));
};

var useMuiGlobalClassesForComponentsProps = function useMuiGlobalClassesForComponentsProps(key, props) {
  var _useContext = useContext(CustomizationsContext),
      componentsCustomizations = _useContext.components;

  var createDepsFromProps = function createDepsFromProps(key, props) {
    var _a, _b, _c, _d;

    return (_d = (_c = (_b = (_a = componentsCustomizations === null || componentsCustomizations === void 0 ? void 0 : componentsCustomizations[key]) === null || _a === void 0 ? void 0 : _a.globalClasses) === null || _b === void 0 ? void 0 : _b.props) === null || _c === void 0 ? void 0 : _c.map(function (prop) {
      return (props === null || props === void 0 ? void 0 : props[prop]) || '';
    })) !== null && _d !== void 0 ? _d : [];
  };

  return useMemo(function () {
    var _a, _b;

    var componentGlobalClasses = (_a = componentsCustomizations === null || componentsCustomizations === void 0 ? void 0 : componentsCustomizations[key]) === null || _a === void 0 ? void 0 : _a.globalClasses;
    var listOfProps = ((_b = componentGlobalClasses === null || componentGlobalClasses === void 0 ? void 0 : componentGlobalClasses.exposeAll) !== null && _b !== void 0 ? _b : false) ? muiComponentsList[key] : componentGlobalClasses === null || componentGlobalClasses === void 0 ? void 0 : componentGlobalClasses.props;
    var propsClasses = listOfProps === null || listOfProps === void 0 ? void 0 : listOfProps.map(function (propName) {
      var propValue = props === null || props === void 0 ? void 0 : props[propName];

      if (typeof propValue === 'string' || typeof propValue === 'number') {
        return "kaltura-ds-" + key + "_" + propName + "-" + propValue;
      } else if (typeof propValue === 'boolean' && propValue) {
        return "kaltura-ds-" + key + "_" + propName;
      }

      return '';
    }).join(' ');
    return "kaltura-ds-" + key + (propsClasses ? " " + propsClasses : '');
  }, createDepsFromProps(key, props));
};

var redefine = redefine$2.exports;

var DatePrototype = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var nativeDateToString = DatePrototype[TO_STRING];
var getTime = DatePrototype.getTime;

// `Date.prototype.toString` method
// https://tc39.es/ecma262/#sec-date.prototype.tostring
if (String(new Date(NaN)) != INVALID_DATE) {
  redefine(DatePrototype, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare -- NaN check
    return value === value ? nativeDateToString.call(this) : INVALID_DATE;
  });
}

/**
 * list of timezone names and their abbreviations,
 * timezone: [standard time, summertime]
 */
var zoneLookup = {
  'Africa/Abidjan': ['GMT'],
  'Africa/Accra': ['GMT'],
  'Africa/Addis_Ababa': ['EAT'],
  'Africa/Algiers': ['CET'],
  'Africa/Asmara': ['EAT'],
  'Africa/Asmera': ['EAT'],
  'Africa/Bamako': ['GMT'],
  'Africa/Bangui': ['WAT'],
  'Africa/Banjul': ['GMT'],
  'Africa/Bissau': ['GMT'],
  'Africa/Blantyre': ['CAT'],
  'Africa/Brazzaville': ['WAT'],
  'Africa/Bujumbura': ['CAT'],
  'Africa/Cairo': ['EET', 'EEST'],
  'Africa/Ceuta': ['CET', 'CEST'],
  'Africa/Conakry': ['GMT'],
  'Africa/Dakar': ['GMT'],
  'Africa/Dar_es_Salaam': ['EAT'],
  'Africa/Djibouti': ['EAT'],
  'Africa/Douala': ['WAT'],
  'Africa/Freetown': ['GMT'],
  'Africa/Gaborone': ['CAT'],
  'Africa/Harare': ['CAT'],
  'Africa/Johannesburg': ['SAST'],
  'Africa/Juba': ['CAT'],
  'Africa/Kampala': ['EAT'],
  'Africa/Khartoum': ['CAT'],
  'Africa/Kigali': ['CAT'],
  'Africa/Kinshasa': ['WAT'],
  'Africa/Lagos': ['WAT'],
  'Africa/Libreville': ['WAT'],
  'Africa/Lome': ['GMT'],
  'Africa/Luanda': ['WAT'],
  'Africa/Lubumbashi': ['CAT'],
  'Africa/Lusaka': ['CAT'],
  'Africa/Malabo': ['WAT'],
  'Africa/Maputo': ['CAT'],
  'Africa/Maseru': ['SAST'],
  'Africa/Mbabane': ['SAST'],
  'Africa/Mogadishu': ['EAT'],
  'Africa/Monrovia': ['GMT'],
  'Africa/Nairobi': ['EAT'],
  'Africa/Ndjamena': ['WAT'],
  'Africa/Niamey': ['WAT'],
  'Africa/Nouakchott': ['GMT'],
  'Africa/Ouagadougou': ['GMT'],
  'Africa/Porto-Novo': ['WAT'],
  'Africa/Sao_Tome': ['GMT'],
  'Africa/Timbuktu': ['GMT'],
  'Africa/Tripoli': ['EET'],
  'Africa/Tunis': ['CET'],
  'Africa/Windhoek': ['CAT'],
  'America/Adak': ['HST', 'HDT'],
  'America/Anchorage': ['AKST', 'AKDT'],
  'America/Anguilla': ['AST'],
  'America/Antigua': ['AST'],
  'America/Aruba': ['AST'],
  'America/Atikokan': ['EST'],
  'America/Atka': ['HST', 'HDT'],
  'America/Bahia_Banderas': ['CST'],
  'America/Barbados': ['AST'],
  'America/Belize': ['CST'],
  'America/Blanc-Sablon': ['AST'],
  'America/Boise': ['MST', 'MDT'],
  'America/Cambridge_Bay': ['MST', 'MDT'],
  'America/Cancun': ['EST'],
  'America/Cayman': ['EST'],
  'America/Chicago': ['CST', 'CDT'],
  'America/Chihuahua': ['CST'],
  'America/Ciudad_Juarez': ['MST', 'MDT'],
  'America/Coral_Harbour': ['EST'],
  'America/Costa_Rica': ['CST'],
  'America/Creston': ['MST'],
  'America/Curacao': ['AST'],
  'America/Danmarkshavn': ['GMT'],
  'America/Dawson': ['MST'],
  'America/Dawson_Creek': ['MST'],
  'America/Denver': ['MST', 'MDT'],
  'America/Detroit': ['EST', 'EDT'],
  'America/Dominica': ['AST'],
  'America/Edmonton': ['MST', 'MDT'],
  'America/El_Salvador': ['CST'],
  'America/Ensenada': ['PST', 'PDT'],
  'America/Fort_Nelson': ['MST'],
  'America/Fort_Wayne': ['EST', 'EDT'],
  'America/Glace_Bay': ['AST', 'ADT'],
  'America/Goose_Bay': ['AST', 'ADT'],
  'America/Grand_Turk': ['EST', 'EDT'],
  'America/Grenada': ['AST'],
  'America/Guadeloupe': ['AST'],
  'America/Guatemala': ['CST'],
  'America/Halifax': ['AST', 'ADT'],
  'America/Havana': ['CST', 'CDT'],
  'America/Hermosillo': ['MST'],
  'America/Indiana/Indianapolis': ['EST', 'EDT'],
  'America/Indiana/Knox': ['CST', 'CDT'],
  'America/Indiana/Marengo': ['EST', 'EDT'],
  'America/Indiana/Petersburg': ['EST', 'EDT'],
  'America/Indiana/Tell_City': ['CST', 'CDT'],
  'America/Indiana/Vevay': ['EST', 'EDT'],
  'America/Indiana/Vincennes': ['EST', 'EDT'],
  'America/Indiana/Winamac': ['EST', 'EDT'],
  'America/Indianapolis': ['EST', 'EDT'],
  'America/Inuvik': ['MST', 'MDT'],
  'America/Iqaluit': ['EST', 'EDT'],
  'America/Jamaica': ['EST'],
  'America/Juneau': ['AKST', 'AKDT'],
  'America/Kentucky/Louisville': ['EST', 'EDT'],
  'America/Kentucky/Monticello': ['EST', 'EDT'],
  'America/Knox_IN': ['CST', 'CDT'],
  'America/Kralendijk': ['AST'],
  'America/Los_Angeles': ['PST', 'PDT'],
  'America/Louisville': ['EST', 'EDT'],
  'America/Lower_Princes': ['AST'],
  'America/Managua': ['CST'],
  'America/Marigot': ['AST'],
  'America/Martinique': ['AST'],
  'America/Matamoros': ['CST', 'CDT'],
  'America/Mazatlan': ['MST'],
  'America/Menominee': ['CST', 'CDT'],
  'America/Merida': ['CST'],
  'America/Metlakatla': ['AKST', 'AKDT'],
  'America/Mexico_City': ['CST'],
  'America/Moncton': ['AST', 'ADT'],
  'America/Monterrey': ['CST'],
  'America/Montreal': ['EST', 'EDT'],
  'America/Montserrat': ['AST'],
  'America/Nassau': ['EST', 'EDT'],
  'America/New_York': ['EST', 'EDT'],
  'America/Nipigon': ['EST', 'EDT'],
  'America/Nome': ['AKST', 'AKDT'],
  'America/North_Dakota/Beulah': ['CST', 'CDT'],
  'America/North_Dakota/Center': ['CST', 'CDT'],
  'America/North_Dakota/New_Salem': ['CST', 'CDT'],
  'America/Ojinaga': ['CST', 'CDT'],
  'America/Panama': ['EST'],
  'America/Pangnirtung': ['EST', 'EDT'],
  'America/Phoenix': ['MST'],
  'America/Port-au-Prince': ['EST', 'EDT'],
  'America/Port_of_Spain': ['AST'],
  'America/Puerto_Rico': ['AST'],
  'America/Rainy_River': ['CST', 'CDT'],
  'America/Rankin_Inlet': ['CST', 'CDT'],
  'America/Regina': ['CST'],
  'America/Resolute': ['CST', 'CDT'],
  'America/Santa_Isabel': ['PST', 'PDT'],
  'America/Santo_Domingo': ['AST'],
  'America/Shiprock': ['MST', 'MDT'],
  'America/Sitka': ['AKST', 'AKDT'],
  'America/St_Barthelemy': ['AST'],
  'America/St_Johns': ['NST', 'NDT'],
  'America/St_Kitts': ['AST'],
  'America/St_Lucia': ['AST'],
  'America/St_Thomas': ['AST'],
  'America/St_Vincent': ['AST'],
  'America/Swift_Current': ['CST'],
  'America/Tegucigalpa': ['CST'],
  'America/Thule': ['AST', 'ADT'],
  'America/Thunder_Bay': ['EST', 'EDT'],
  'America/Tijuana': ['PST', 'PDT'],
  'America/Toronto': ['EST', 'EDT'],
  'America/Tortola': ['AST'],
  'America/Vancouver': ['PST', 'PDT'],
  'America/Virgin': ['AST'],
  'America/Whitehorse': ['MST'],
  'America/Winnipeg': ['CST', 'CDT'],
  'America/Yakutat': ['AKST', 'AKDT'],
  'America/Yellowknife': ['MST', 'MDT'],
  'Antarctica/Macquarie': ['AEST', 'AEDT'],
  'Antarctica/McMurdo': ['NZST', 'NZDT'],
  'Antarctica/South_Pole': ['NZST', 'NZDT'],
  'Arctic/Longyearbyen': ['CET', 'CEST'],
  'Asia/Beirut': ['EET', 'EEST'],
  'Asia/Calcutta': ['IST'],
  'Asia/Chongqing': ['CST'],
  'Asia/Chungking': ['CST'],
  'Asia/Famagusta': ['EET', 'EEST'],
  'Asia/Gaza': ['EET', 'EEST'],
  'Asia/Harbin': ['CST'],
  'Asia/Hebron': ['EET', 'EEST'],
  'Asia/Hong_Kong': ['HKT'],
  'Asia/Jakarta': ['WIB'],
  'Asia/Jayapura': ['WIT'],
  'Asia/Jerusalem': ['IST', 'IDT'],
  'Asia/Karachi': ['PKT'],
  'Asia/Kolkata': ['IST'],
  'Asia/Macao': ['CST'],
  'Asia/Macau': ['CST'],
  'Asia/Makassar': ['WITA'],
  'Asia/Manila': ['PHT'],
  'Asia/Nicosia': ['EET', 'EEST'],
  'Asia/Pontianak': ['WIB'],
  'Asia/Pyongyang': ['KST'],
  'Asia/Seoul': ['KST'],
  'Asia/Shanghai': ['CST'],
  'Asia/Taipei': ['CST'],
  'Asia/Tel_Aviv': ['IST', 'IDT'],
  'Asia/Tokyo': ['JST'],
  'Asia/Ujung_Pandang': ['WITA'],
  'Atlantic/Bermuda': ['AST', 'ADT'],
  'Atlantic/Canary': ['WET', 'WEST'],
  'Atlantic/Faeroe': ['WET', 'WEST'],
  'Atlantic/Faroe': ['WET', 'WEST'],
  'Atlantic/Jan_Mayen': ['CET', 'CEST'],
  'Atlantic/Madeira': ['WET', 'WEST'],
  'Atlantic/Reykjavik': ['GMT'],
  'Atlantic/St_Helena': ['GMT'],
  'Australia/ACT': ['AEST', 'AEDT'],
  'Australia/Adelaide': ['ACST', 'ACDT'],
  'Australia/Brisbane': ['AEST'],
  'Australia/Broken_Hill': ['ACST', 'ACDT'],
  'Australia/Canberra': ['AEST', 'AEDT'],
  'Australia/Currie': ['AEST', 'AEDT'],
  'Australia/Darwin': ['ACST'],
  'Australia/Hobart': ['AEST', 'AEDT'],
  'Australia/Lindeman': ['AEST'],
  'Australia/Melbourne': ['AEST', 'AEDT'],
  'Australia/North': ['ACST'],
  'Australia/NSW': ['AEST', 'AEDT'],
  'Australia/Perth': ['AWST'],
  'Australia/Queensland': ['AEST'],
  'Australia/South': ['ACST', 'ACDT'],
  'Australia/Sydney': ['AEST', 'AEDT'],
  'Australia/Tasmania': ['AEST', 'AEDT'],
  'Australia/Victoria': ['AEST', 'AEDT'],
  'Australia/West': ['AWST'],
  'Australia/Yancowinna': ['ACST', 'ACDT'],
  'Canada/Atlantic': ['AST', 'ADT'],
  'Canada/Central': ['CST', 'CDT'],
  'Canada/Eastern': ['EST', 'EDT'],
  'Canada/Mountain': ['MST', 'MDT'],
  'Canada/Newfoundland': ['NST', 'NDT'],
  'Canada/Pacific': ['PST', 'PDT'],
  'Canada/Saskatchewan': ['CST'],
  'Canada/Yukon': ['MST'],
  'CET': ['CET', 'CEST'],
  'Cuba': ['CST', 'CDT'],
  'EET': ['EET', 'EEST'],
  'Egypt': ['EET', 'EEST'],
  'Eire': ['IST', 'GMT'],
  'EST': ['EST'],
  'Etc/GMT': ['GMT'],
  'Etc/Greenwich': ['GMT'],
  'Etc/UCT': ['UTC'],
  'Etc/Universal': ['UTC'],
  'Etc/UTC': ['UTC'],
  'Etc/Zulu': ['UTC'],
  'Europe/Amsterdam': ['CET', 'CEST'],
  'Europe/Andorra': ['CET', 'CEST'],
  'Europe/Athens': ['EET', 'EEST'],
  'Europe/Belfast': ['GMT', 'BST'],
  'Europe/Belgrade': ['CET', 'CEST'],
  'Europe/Berlin': ['CET', 'CEST'],
  'Europe/Bratislava': ['CET', 'CEST'],
  'Europe/Brussels': ['CET', 'CEST'],
  'Europe/Bucharest': ['EET', 'EEST'],
  'Europe/Budapest': ['CET', 'CEST'],
  'Europe/Busingen': ['CET', 'CEST'],
  'Europe/Chisinau': ['EET', 'EEST'],
  'Europe/Copenhagen': ['CET', 'CEST'],
  'Europe/Dublin': ['IST', 'GMT'],
  'Europe/Gibraltar': ['CET', 'CEST'],
  'Europe/Guernsey': ['GMT', 'BST'],
  'Europe/Helsinki': ['EET', 'EEST'],
  'Europe/Isle_of_Man': ['GMT', 'BST'],
  'Europe/Jersey': ['GMT', 'BST'],
  'Europe/Kaliningrad': ['EET'],
  'Europe/Kiev': ['EET', 'EEST'],
  'Europe/Kirov': ['MSK'],
  'Europe/Kyiv': ['EET', 'EEST'],
  'Europe/Lisbon': ['WET', 'WEST'],
  'Europe/Ljubljana': ['CET', 'CEST'],
  'Europe/London': ['GMT', 'BST'],
  'Europe/Luxembourg': ['CET', 'CEST'],
  'Europe/Madrid': ['CET', 'CEST'],
  'Europe/Malta': ['CET', 'CEST'],
  'Europe/Mariehamn': ['EET', 'EEST'],
  'Europe/Monaco': ['CET', 'CEST'],
  'Europe/Moscow': ['MSK'],
  'Europe/Nicosia': ['EET', 'EEST'],
  'Europe/Oslo': ['CET', 'CEST'],
  'Europe/Paris': ['CET', 'CEST'],
  'Europe/Podgorica': ['CET', 'CEST'],
  'Europe/Prague': ['CET', 'CEST'],
  'Europe/Riga': ['EET', 'EEST'],
  'Europe/Rome': ['CET', 'CEST'],
  'Europe/San_Marino': ['CET', 'CEST'],
  'Europe/Sarajevo': ['CET', 'CEST'],
  'Europe/Simferopol': ['MSK'],
  'Europe/Skopje': ['CET', 'CEST'],
  'Europe/Sofia': ['EET', 'EEST'],
  'Europe/Stockholm': ['CET', 'CEST'],
  'Europe/Tallinn': ['EET', 'EEST'],
  'Europe/Tirane': ['CET', 'CEST'],
  'Europe/Tiraspol': ['EET', 'EEST'],
  'Europe/Uzhgorod': ['EET', 'EEST'],
  'Europe/Vaduz': ['CET', 'CEST'],
  'Europe/Vatican': ['CET', 'CEST'],
  'Europe/Vienna': ['CET', 'CEST'],
  'Europe/Vilnius': ['EET', 'EEST'],
  'Europe/Volgograd': ['MSK'],
  'Europe/Warsaw': ['CET', 'CEST'],
  'Europe/Zagreb': ['CET', 'CEST'],
  'Europe/Zaporozhye': ['EET', 'EEST'],
  'Europe/Zurich': ['CET', 'CEST'],
  'GB': ['GMT', 'BST'],
  'GB-Eire': ['GMT', 'BST'],
  'GMT': ['GMT'],
  'Greenwich': ['GMT'],
  'Hongkong': ['HKT'],
  'HST': ['HST'],
  'Iceland': ['GMT'],
  'Indian/Antananarivo': ['EAT'],
  'Indian/Comoro': ['EAT'],
  'Indian/Mayotte': ['EAT'],
  'Israel': ['IST', 'IDT'],
  'Jamaica': ['EST'],
  'Japan': ['JST'],
  'Libya': ['EET'],
  'MET': ['MET', 'MEST'],
  'Mexico/BajaNorte': ['PST', 'PDT'],
  'Mexico/BajaSur': ['MST'],
  'Mexico/General': ['CST'],
  'MST': ['MST'],
  'Navajo': ['MST', 'MDT'],
  'NZ': ['NZST', 'NZDT'],
  'Pacific/Auckland': ['NZST', 'NZDT'],
  'Pacific/Honolulu': ['HST'],
  'Pacific/Johnston': ['HST'],
  'Pacific/Midway': ['SST'],
  'Pacific/Pago_Pago': ['SST'],
  'Pacific/Saipan': ['CHST'],
  'Pacific/Samoa': ['SST'],
  'Poland': ['CET', 'CEST'],
  'Portugal': ['WET', 'WEST'],
  'PRC': ['CST'],
  'ROC': ['CST'],
  'ROK': ['KST'],
  'UCT': ['UTC'],
  'Universal': ['UTC'],
  'US/Alaska': ['AKST', 'AKDT'],
  'US/Aleutian': ['HST', 'HDT'],
  'US/Arizona': ['MST'],
  'US/Central': ['CST', 'CDT'],
  'US/East-Indiana': ['EST', 'EDT'],
  'US/Eastern': ['EST', 'EDT'],
  'US/Hawaii': ['HST'],
  'US/Indiana-Starke': ['CST', 'CDT'],
  'US/Michigan': ['EST', 'EDT'],
  'US/Mountain': ['MST', 'MDT'],
  'US/Pacific': ['PST', 'PDT'],
  'US/Samoa': ['SST'],
  'UTC': ['UTC'],
  'W-SU': ['MSK'],
  'WET': ['WET', 'WEST'],
  'Zulu': ['UTC']
};
/**
 * is the given date in Daylight Saving Time
 * @param date
 * @param timezone
 */

function isDaylightSaving(date, timezone) {
  // what we want to check
  var targetDate = new Date(date.toLocaleString('en-US', {
    timeZone: timezone
  })); // the locale doesn't matter, only the timezone

  var targetOffset = targetDate.getTimezoneOffset();
  var jan = new Date(targetDate.getFullYear(), 0, 1);
  var jul = new Date(targetDate.getFullYear(), 6, 1);
  var dstOffset = Math.min(jan.getTimezoneOffset(), jul.getTimezoneOffset());
  return targetOffset === dstOffset;
}
/**
 * dayjs plugin to support timezone names abbreviations
 * when formatting, ie IST, IDT, CET
 *
 * this plugin depends on dayjs's timezone plugin,
 * which in turn depends on utc plugin.
 *
 * to use, load and extend like other dayjs plugins:
 * import { timezoneAbbr } from "@kaltura-ds/utils";
 * dayjs.extend(timezoneAbbr);
 */


var timezoneAbbr = function timezoneAbbr(o, c, d) {
  var proto = c.prototype;
  var oldOffsetName = proto.offsetName;

  proto.offsetName = function (type) {
    // only if asked for short name
    if (!type || type === 'short') {
      var zone = this.$x.$timezone || d.tz.guess();

      if (zoneLookup[zone]) {
        // we have data, is dst on?
        var isDSTon = isDaylightSaving(this.toDate(), zone);

        if (isDSTon && zoneLookup[zone].length > 1) {
          // we have DST data and we need it
          return zoneLookup[zone][1];
        } // return non DST name


        return zoneLookup[zone][0];
      }
    }

    return oldOffsetName.call(this, type);
  };
};

export { BitsComponents, CustomizationsContext, CustomizationsProvider, InteractionsContext, InteractionsProvider, InteractionsTypes, MuiComponents, timezoneAbbr, useGlobalClassesForComponentsProps, useMuiGlobalClassesForComponentsProps };
